import { Outlet } from "react-router";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Header from "../components/Header/Header";
import Container from "react-bootstrap/Container";
import Placeholders from "../components/Placeholders";
import Footer from "../components/Footer/Footer";
import LastFooter from "../components/Footer/LastFooter";
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";

export default function Layout() {
    return (
        <div className='bg-body-tertiary min-vh-100'>
            <Container fluid>
                <Row className="sticky-top shadow"><Col xs={12} className="p-0"><Header /></Col><Col xs={12} className="m-0 p-0"><Breadcrumbs /></Col></Row>
                <Row><Col className="p-0"><Outlet /></Col></Row>
                <Row><Col className="p-0"><Placeholders /></Col></Row>
                <Row><Col className="p-0"><Footer /></Col></Row>
                <Row><Col className="p-0"><LastFooter /></Col></Row>
            </Container>
        </div>
    )
}